import { __assign } from "tslib";
import { buildSchema } from 'graphql';
import { printSchemaWithDirectives } from './print-schema-with-directives';
function buildFixedSchema(schema, options) {
    return buildSchema(printSchemaWithDirectives(schema, options), __assign({ noLocation: true }, (options || {})));
}
export function fixSchemaAst(schema, options) {
    var schemaWithValidAst;
    if (!schema.astNode) {
        Object.defineProperty(schema, 'astNode', {
            get: function () {
                if (!schemaWithValidAst) {
                    schemaWithValidAst = buildFixedSchema(schema, options);
                }
                return schemaWithValidAst.astNode;
            },
        });
    }
    if (!schema.extensionASTNodes) {
        Object.defineProperty(schema, 'extensionASTNodes', {
            get: function () {
                if (!schemaWithValidAst) {
                    schemaWithValidAst = buildFixedSchema(schema, options);
                }
                return schemaWithValidAst.extensionASTNodes;
            },
        });
    }
    return schema;
}
//# sourceMappingURL=fix-schema-ast.js.map